import { FunctionComponent } from 'preact';
import { useCallback } from 'preact/hooks';

import { IconButton, IconButtonProps } from '../IconButton/IconButton';
import { usePlayerMute } from '../../hooks/usePlayerMute';
import { useKeyboardHandler } from '../../hooks/useKeyboardHandler';
import { useTracker } from '../../hooks/useTracker';
import { useIcons } from '../../hooks/useIcons';
import { useTpaasTracker } from '../../hooks/useTpaasTracker';

export const ToggleSoundButton: FunctionComponent<IconButtonProps> = (
  props
) => {
  const { isMuted, toggleMute } = usePlayerMute();
  const { trackButtonClick } = useTracker();
  const { AudioOn, AudioOff } = useIcons();
  const { trackEngagementUIElement } = useTpaasTracker();

  const Icon = isMuted ? AudioOff : AudioOn;

  const handleKeydown = useCallback(
    (e: KeyboardEvent) => {
      if (e.code === 'KeyM') {
        toggleMute();
      }
    },
    [toggleMute]
  );

  useKeyboardHandler(handleKeydown);

  const handleClick = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation();
      toggleMute();
      trackButtonClick('toggle-sound');
      if (e.currentTarget instanceof Element) {
        trackEngagementUIElement({
          elementName: 'Toggle Sound',
          elementType: e.currentTarget.tagName.toLowerCase(),
          name: isMuted ? 'Unmute' : 'Mute',
        });
      }
    },
    [toggleMute, trackButtonClick, isMuted, trackEngagementUIElement]
  );

  return (
    <IconButton onClick={handleClick} {...props}>
      <Icon />
    </IconButton>
  );
};
